import classNames from "classnames";
import { type HTMLAttributes } from "react";

import { type Prettify, type User } from "@/types";

import UserAvatar, { type UserAvatarProps } from "../media/UserAvatar";

type Props = HTMLAttributes<HTMLDivElement> & {
  user: Prettify<User<true> | User<true, false, true>>;
  size?: UserAvatarProps["size"];
};

const textSizes = {
  xs: "text-sm",
  sm: "text-sm",
  md: "text-sm font-medium",
  lg: "text-base font-semibold",
  xl: "text-lg font-semibold",
  "2xl": "text-lg font-semibold",
  "3xl": "text-lg font-semibold",
  "4xl": "text-lg font-semibold",
  "5xl": "text-lg font-semibold",
};

const gapSizes = {
  xs: "gap-2",
  sm: "gap-2",
  md: "gap-3",
  lg: "gap-4",
  xl: "gap-5",
  "2xl": "gap-5",
  "3xl": "gap-6",
  "4xl": "gap-6",
  "5xl": "gap-6",
};

export default function UserCard({
  user,
  className,
  size = "md",
  ...props
}: Props) {
  return (
    <div
      className={classNames(
        "flex items-center rounded-lg select-none",
        props.onClick && "cursor-pointer hover:bg-gray-50",
        className,
        gapSizes[size],
      )}
      {...props}
    >
      <UserAvatar user={user} size={size} />
      <div className={classNames("flex flex-col", textSizes[size])}>
        <div className={classNames("text-gray-900")}>
          {user.first_name + " " + user.last_name}
        </div>
        <div className="font-normal text-gray-600">{user.position?.name}</div>
      </div>
    </div>
  );
}
